import { render, staticRenderFns } from "./401.vue?vue&type=template&id=9019ac9a&scoped=true&"
import script from "./401.vue?vue&type=script&lang=js&"
export * from "./401.vue?vue&type=script&lang=js&"
import style0 from "./401.vue?vue&type=style&index=0&id=9019ac9a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9019ac9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9019ac9a')) {
      api.createRecord('9019ac9a', component.options)
    } else {
      api.reload('9019ac9a', component.options)
    }
    module.hot.accept("./401.vue?vue&type=template&id=9019ac9a&scoped=true&", function () {
      api.rerender('9019ac9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/errorPage/401.vue"
export default component.exports